var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pesquisa-tecnica-view"},[_c('PesquisaBot')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }